import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
export default DragDropContext(HTML5Backend);



// WEBPACK FOOTER //
// ./components/withdrag-dropcontext/index.tsx